import { TbChevronsLeft, TbChevronsRight } from 'react-icons/tb'
import { Text } from 'ui-kit/typography'
import { PaginationProps, usePagination } from 'hooks/usePagination'
import clsx from 'clsx'
import classes from './ScenariosPagination.module.scss'

type ScenariosPaginationProps = PaginationProps & {
  currentPage: number
  onPageChange: (page: number) => void
}

export const ScenariosPagination = ({
  totalCount,
  siblingCount = 1,
  pageSize,
  currentPage,
  onPageChange,
  className,
}: ScenariosPaginationProps) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  const onNextArrowClick = () => {
    onPageChange(currentPage + 1)
  }

  const onPreviousArrowClick = () => {
    onPageChange(currentPage - 1)
  }

  const lastPage =
    paginationRange && paginationRange[paginationRange.length - 1]

  return (
    <ul className={clsx(classes.list, className)}>
      <li
        key={'arrow-left'}
        onClick={onPreviousArrowClick}
        className={clsx(
          classes.item,
          classes.item__leftArrow,
          currentPage === 1 && classes.item__disabled,
        )}
      >
        <TbChevronsLeft />
      </li>

      {paginationRange &&
        paginationRange.map((pageNumber, idx) =>
          typeof pageNumber === 'number' ? (
            <li
              key={idx}
              onClick={() => onPageChange(pageNumber)}
              className={clsx(
                classes.item,
                pageNumber === currentPage && classes.item__selected,
              )}
            >
              <Text as={'span'} className={classes.number}>
                {pageNumber}
              </Text>
            </li>
          ) : (
            <li key={idx} className={clsx(classes.item, classes.item__dots)}>
              <Text as={'span'}>&#8230;</Text>
            </li>
          ),
        )}

      <li
        key={'arrow-right'}
        onClick={onNextArrowClick}
        className={clsx(
          classes.item,
          classes.item__rightArrow,
          currentPage === lastPage && classes.item__disabled,
        )}
      >
        <TbChevronsRight />
      </li>
    </ul>
  )
}
